import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "@components/index";
import { Navigate, useLocation, useOutlet } from "react-router-dom";
import { Content } from "antd/lib/layout/layout";
import { useEffect, useState } from "react";
export const GlobalLayout = () => {
  const { Content, Sider } = Layout;
  const outlet = useOutlet();
  const [height, setHeight] = useState(0);
  const { pathname } = useLocation();

  useEffect(() => {
    setHeight(window.innerHeight - 1);

    window.addEventListener("resize", () => {
      setHeight(window.innerHeight - 1);
    });
  }, []);
  return (
    <ErrorBoundary>
      <Layout className={pathname.includes("/auth") ? "authRoute" : ""}>
        <ErrorBoundary>
          <Content
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              backgroundColor: "#F9FBFD",
              height,
              width: "100%",
              paddingInline: 0,
            }}
          >
            {outlet}
          </Content>
        </ErrorBoundary>
      </Layout>
    </ErrorBoundary>
  );
};
